<template>
  <div class="mobile-invoice-list">
    <div class="mobile-invoice-list__header">
      <div class="left-top">
        <img src="@imgs/back_mobile.png" @click="goBack()" alt="" class="input_icon input_sear" />
      </div>
      <div class="top-title">{{ title == 'list' ? '开发票' : '查看开票记录' }}</div>
    </div>
    <submit-invoice-content ref="submitInvoiceRef" v-if="isSubmit && isMobile" :ids="ids" />
    <ul class="mobile-invoice-list__content" v-if="!isSubmit">
      <li v-for="item in tableData" :key="item.id">
        <div class="info-check" v-if="title == 'list'">
          <el-checkbox v-model="item['isCheck']" @change="handleChecked(item)"></el-checkbox>
        </div>
        <div class="info-wrapper">
          <div class="info-wrapper__title" :class="title !== 'list' && 'title-flex'">
            <p>
              <span :class="title === 'list' ? 'w-28' : 'w-62'">{{ detail.titleName }}</span>
              <span :class="title === 'list' ? 'w-170' : 'w-140'">{{ item[detail.title] }}</span>
            </p>
            <span class="main-text">{{ item['invoiceStatus'] }}</span>
          </div>
          <div class="info-wrapper__detail">
            <div>
              <p>
                {{ detail.infoName1 }}<span>{{ item[detail.infoContent1] }}</span>
              </p>
              <p>
                {{ detail.infoName2 }}<span>{{ item[detail.infoContent2] }}</span>
              </p>
              <p>
                {{ detail.infoName3 }}<span>{{ item[detail.infoContent3] }}</span>
              </p>
            </div>
            <span class="amount">{{ item[detail.amount] }}</span>
          </div>
        </div>
      </li>
    </ul>
    <div class="mobile-invoice-list__footer" v-if="title == 'list' && !isSubmit">
      <p>
        已选订单金额：<span class="main-color">{{ amount }}</span> 元
      </p>
      <el-checkbox v-model="isCheckAll" @change="checkAll">全选</el-checkbox>
      <span class="btn" @click="submit">提交开票</span>
    </div>
  </div>
</template>

<script>
import invoice from '@api/invoice'
import moment from 'moment/moment'
import submitInvoiceContent from '@components/personalPage/components/SubmitInvoiceContent'

export default {
  name: 'MobileInvoiceList',
  props: {
    title: {
      type: String
    }
  },
  components: { submitInvoiceContent },
  data() {
    return {
      amountAry: [],
      amount: 0,
      isCheckAll: false,
      tableData: [],
      detail: {},
      isSubmit: false,
      ids: ''
    }
  },
  created() {
    if (this.title == 'list') {
      this.getData()
      this.detail = {
        titleName: '订阅内容：',
        title: 'worksName',
        infoName1: '订阅日期：',
        infoContent1: 'createTime',
        infoName2: '出版单位：',
        infoContent2: 'publishUnit',
        // info3: 'createTime',
        amount: 'orderAmount'
      }
    }
    if (this.title == 'record') {
      this.getRecordData()
      this.detail = {
        titleName: '开票方：',
        title: 'invoiceAccount',
        infoName1: '申请单号：',
        infoContent1: 'applyNumber',
        infoName2: '开票日期：',
        infoContent2: 'createTime',
        infoName3: '联系方式：',
        infoContent3: 'contactWay',
        amount: 'invoiceAmount',
        invoiceStatus: 'invoiceStatus'
      }
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.book.isMobile
    }
  },
  methods: {
    goBack() {
      if (this.isSubmit) {
        this.isSubmit = false
      } else {
        this.$parent.currentModule = 'orderRec'
      }
    },
    handleSelectionChange(val) {
      this.ids = val.map((_) => _.id).join()
      let a = 0
      a = val.reduce((prev, curr) => {
        return prev + curr.orderAmount
      }, 0)
      this.amount = a.toFixed(2)
    },
    handleChecked(item) {
      if (item.isCheck) {
        this.amountAry.push(item)
      } else {
        let idx = this.amountAry.findIndex((ele) => !ele.isCheck)
        this.amountAry.splice(idx, 1)
      }
      this.isCheckAll = this.tableData.every((_) => _.isCheck)
      this.handleSelectionChange(this.amountAry)
    },
    checkAll(val) {
      this.tableData.forEach((_) => {
        _.isCheck = val
      })
      this.handleSelectionChange(this.tableData.filter((_) => _.isCheck))
    },
    submit() {
      this.isSubmit = true
    },
    getData() {
      let params = {
        pageNo: 1,
        pageSize: 9999
      }
      /*this.tableData = [
        {
          creator: '18203190952', // 创建书刊的用户
          subscriber: '18937196209', // 下单用户
          worksName: '高中朝鲜语文必高中朝鲜语文必修第3册修第3册.加水印', //  订阅内容
          subscribeId: 18,
          publishUnit: '方正出版', // 出版单位
          orderAmount: 0.08, // 订单金额
          worksId: 1604,
          createTime: 1684230481000, //  订阅日期
          worksType: 'cloud_read_ebook',
          startTime: 1684230481000,
          orderCode: '202305160000132280',
          id: 1,
          endTime: 2630915281000,
          applyStauts: 0
        },
        {
          creator: '18203190952', // 创建书刊的用户
          subscriber: '18937196209', // 下单用户
          worksName: '高中朝鲜语文必修第1册.加水印', //  订阅内容
          subscribeId: 18,
          publishUnit: '方正出版', // 出版单位
          orderAmount: 0.01, // 订单金额
          worksId: 1604,
          createTime: 1684230481000, //  订阅日期
          worksType: 'cloud_read_ebook',
          startTime: 1684230481000,
          orderCode: '202305160000132280',
          id: 2,
          endTime: 2630915281000,
          applyStauts: 0
        },
        {
          creator: '18203190952', // 创建书刊的用户
          subscriber: '18937196209', // 下单用户
          worksName: '高中朝鲜语文必修第2册.加水印', //  订阅内容
          subscribeId: 18,
          publishUnit: '方正出版', // 出版单位
          orderAmount: 3.21, // 订单金额
          worksId: 1604,
          createTime: 1684230481000, //  订阅日期
          worksType: 'cloud_read_ebook',
          startTime: 1684230481000,
          orderCode: '202305160000132280',
          id: 3,
          endTime: 2630915281000,
          applyStauts: 0
        },
        {
          creator: '18203190952', // 创建书刊的用户
          subscriber: '18937196209', // 下单用户
          worksName: '高中朝鲜语文必修第2册.加水印', //  订阅内容
          subscribeId: 18,
          publishUnit: '方正出版', // 出版单位
          orderAmount: 3.21, // 订单金额
          worksId: 1604,
          createTime: 1684230481000, //  订阅日期
          worksType: 'cloud_read_ebook',
          startTime: 1684230481000,
          orderCode: '202305160000132280',
          id: 4,
          endTime: 2630915281000,
          applyStauts: 0
        },
        {
          creator: '18203190952', // 创建书刊的用户
          subscriber: '18937196209', // 下单用户
          worksName: '高中朝鲜语文必修第2册.加水印', //  订阅内容
          subscribeId: 18,
          publishUnit: '方正出版', // 出版单位
          orderAmount: 3.21, // 订单金额
          worksId: 1604,
          createTime: 1684230481000, //  订阅日期
          worksType: 'cloud_read_ebook',
          startTime: 1684230481000,
          orderCode: '202305160000132280',
          id: 5,
          endTime: 2630915281000,
          applyStauts: 0
        },
        {
          creator: '18203190952', // 创建书刊的用户
          subscriber: '18937196209', // 下单用户
          worksName: '高中朝鲜语文必修第2册.加水印', //  订阅内容
          subscribeId: 18,
          publishUnit: '方正出版', // 出版单位
          orderAmount: 3.21, // 订单金额
          worksId: 1604,
          createTime: 1684230481000, //  订阅日期
          worksType: 'cloud_read_ebook',
          startTime: 1684230481000,
          orderCode: '202305160000132280',
          id: 6,
          endTime: 2630915281000,
          applyStauts: 0
        },
        {
          creator: '18203190952', // 创建书刊的用户
          subscriber: '18937196209', // 下单用户
          worksName: '高中朝鲜语文必修第2册.加水印', //  订阅内容
          subscribeId: 18,
          publishUnit: '方正出版', // 出版单位
          orderAmount: 3.21, // 订单金额
          worksId: 1604,
          createTime: 1684230481000, //  订阅日期
          worksType: 'cloud_read_ebook',
          startTime: 1684230481000,
          orderCode: '202305160000132280',
          id: 67,
          endTime: 2630915281000,
          applyStauts: 0
        },
        {
          creator: '18203190952', // 创建书刊的用户
          subscriber: '18937196209', // 下单用户
          worksName: '高中朝鲜语文必修第2册.加水印', //  订阅内容
          subscribeId: 18,
          publishUnit: '方正出版', // 出版单位
          orderAmount: 3.21, // 订单金额
          worksId: 1604,
          createTime: 1684230481000, //  订阅日期
          worksType: 'cloud_read_ebook',
          startTime: 1684230481000,
          orderCode: '202305160000132280',
          id: 8,
          endTime: 2630915281000,
          applyStauts: 0
        },
        {
          creator: '18203190952', // 创建书刊的用户
          subscriber: '18937196209', // 下单用户
          worksName: '高中朝鲜语文必修第2册.加水印', //  订阅内容
          subscribeId: 18,
          publishUnit: '方正出版', // 出版单位
          orderAmount: 3.21, // 订单金额
          worksId: 1604,
          createTime: 1684230481000, //  订阅日期
          worksType: 'cloud_read_ebook',
          startTime: 1684230481000,
          orderCode: '202305160000132280',
          id: 9,
          endTime: 2630915281000,
          applyStauts: 0
        },
        {
          creator: '18203190952', // 创建书刊的用户
          subscriber: '18937196209', // 下单用户
          worksName: '高中朝鲜语文必修第2册.加水印', //  订阅内容
          subscribeId: 18,
          publishUnit: '方正出版', // 出版单位
          orderAmount: 3.21, // 订单金额
          worksId: 1604,
          createTime: 1684230481000, //  订阅日期
          worksType: 'cloud_read_ebook',
          startTime: 1684230481000,
          orderCode: '202305160000132280',
          id: 10,
          endTime: 2630915281000,
          applyStauts: 0
        },
        {
          creator: '18203190952', // 创建书刊的用户
          subscriber: '18937196209', // 下单用户
          worksName: '高中朝鲜语文必修第2册.加水印', //  订阅内容
          subscribeId: 18,
          publishUnit: '方正出版', // 出版单位
          orderAmount: 3.21, // 订单金额
          worksId: 1604,
          createTime: 1694685712000, //  订阅日期
          worksType: 'cloud_read_ebook',
          startTime: 1684230481000,
          orderCode: '202305160000132280',
          id: 13,
          endTime: 2630915281000,
          applyStauts: 0
        },
        {
          creator: '18203190952', // 创建书刊的用户
          subscriber: '18937196209', // 下单用户
          worksName: '高中朝鲜语文必修第2册.加水印', //  订阅内容
          subscribeId: 18,
          publishUnit: '方正出版', // 出版单位
          orderAmount: 3.21, // 订单金额
          worksId: 1604,
          createTime: 1684230481000, //  订阅日期
          worksType: 'cloud_read_ebook',
          startTime: 1684230481000,
          orderCode: '202305160000132280',
          id: 23,
          endTime: 2630915281000,
          applyStauts: 0
        }
      ]
      return*/
      invoice.findSubscribeRecordOrderByPage(params).then((res) => {
        let { status, data } = res.data
        if (status == 0) {
          this.tableData = data.page.result
          this.tableData.forEach((_) => {
            _.createTime = moment(_.createTime).format('YY-MM-DD')
            this.$set(_, 'isCheck', false)
          })
        }
      })
    },
    getRecordData() {
      let params = {
        pageNo: 1,
        pageSize: 9999
      }
      invoice.findInvoiceByPage(params).then((res) => {
        let { status, data } = res.data
        if (status == 0) {
          this.tableData = data.page.result
          this.tableData.forEach((_) => {
            _.createTime = moment(_.createTime).format('YY-MM-DD')
            if (_.invoiceStatus == 0) _.invoiceStatus = '已通知出版单位'
            if (_.invoiceStatus == 1) _.invoiceStatus = '已开票'
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.mobile-invoice-list {
  &__header {
    display: flex;
    justify-content: center;
    height: 55px;
    border-bottom: #eaeaea 1px solid;
    position: relative;
    width: calc(100% - 40px);
    margin-left: 20px;
    img {
      width: 26px;
    }
    .top-title {
      line-height: 55px;
      font-size: 16px;
      font-weight: 600;
    }
    .left-top {
      position: absolute;
      left: 0;
      top: 15px;
    }
  }

  &__content {
    padding: 0 20px;
    max-height: 700px;
    overflow-y: scroll;
    li {
      display: flex;
      margin: 10px 0;
      padding-bottom: 13px;
      border-bottom: 1px solid #f3f3f7;
      .info-check {
        margin-right: 25px;
        margin-top: 22px;
        /deep/.el-checkbox__inner {
          //width: 18px;
          //height: 18px;
        }
        /deep/.el-checkbox__inner:hover {
        }
      }
      .info-wrapper {
        width: 100%;
        &__title {
          align-items: baseline;
          font-size: 14px;
          p {
            display: flex;
            font-weight: bold;
            margin: 5px 0;
          }
          .main-text {
            width: 110px;
            //margin-left: auto;
            font-size: 12px;
          }
          line-height: 25px;
          .w-140 {
            width: 140px;
            word-break: break-all;
          }
          .w-170 {
            width: 170px;
            flex: 1;
          }
          .w-62 {
            width: 62px;
          }
          .w-28 {
            width: 28%;
          }
        }
        .title-flex {
          display: flex;
          justify-content: space-between;
        }
        &__detail {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          p {
            margin: 0;
            color: #515151;
            font-size: 12px;
            line-height: 20px;
          }
          .amount {
            margin-right: 38px;
            line-height: 25px;
            font-size: 18px;
          }
        }
      }
    }
  }

  &__footer {
    position: fixed;
    bottom: 0;
    display: flex;
    width: 100%;
    justify-content: space-evenly;
    align-items: center;
    box-shadow: 0px 2px 5px 0px #cecece;
    height: 75px;
    z-index: 99;
    background-color: #fff;
    font-size: 14px;

    .el-radio {
      margin-right: 0;
    }

    .btn {
      display: inline-block;
      width: 100px;
      height: 30px;
      font-weight: 500;
      color: #ffffff;
      line-height: 30px;
      background-color: #df5813;
      //border-radius: 6px;
      text-align: center;
      cursor: pointer;
      margin-left: 20px;
    }
  }
}
</style>
